/*
 * File: index.ts
 * File Created: 2024-02-02 07:43:38
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-02 10:28:33
 * Modified By: Val Liu
 * -----
 */

// import { ALLOW_GENERAL_MODIFY, ALLOW_GENERAL_READ } from "@/helpers/permission-helper";
import { PARAMS_INCLUDE, PARAMS_WHERE } from "@/views/core";
import { IPermissionCheck, ObjectHelper, Vue } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";
// import { EOrganizationRolePermission } from "shared-taiwan-bank-life-insurance";
const _ = UIQuick.getInstance;

// const rolePermission: EOrganizationRolePermission = EOrganizationRolePermission.系統維護管理作業;

@UIQuick.set()
export class Organization extends IQuickUnit {
    title = "w_MenuOrgList";
    path = "/organization";
    icon = "fa-solid fa-briefcase";

    /// hireachy
    parents = () => [_`User`];
    children = () => [_`Membership`, _`Wallet`];

    /// file
    file = false;

    /// params
    paramsWhere = PARAMS_WHERE;
    paramsRead = function(this) {
        return ObjectHelper.deepMerge(
            PARAMS_INCLUDE.call(this),
            {
                include: {
                    _count: {
                        select: {
                            memberships: true,
                        }
                    }
                }
            }
        );
    };
    paramsUpdate = PARAMS_INCLUDE;

    /// interfaces
    infDetail = require("raw-loader!./interfaces/organization.create.interface").default;
    infRead = require("raw-loader!./interfaces/organization.read.interface").default;
    infCreate = require("raw-loader!./interfaces/organization.create.interface").default;
    infUpdate = require("raw-loader!./interfaces/organization.create.interface").default;
    infDelete = require("raw-loader!./interfaces/organization.delete.interface").default;
}
